/*
  UI to handle editing a specific rate schedule group.
*/
import {RateScheduleGroupEditorRateSchedules} from 'admin/accounting/rate_schedule_group_editor_rate_schedules'

class RateScheduleGroupEditor extends HTMLElement {
  constructor() {
    super();
  }

  async loadData(){
    this.groupId = this.getAttribute("group_id")
    let url = `/admin/rate_schedule_groups/${this.groupId}/editor_data`
    if (this.groupId === "") {
      url = `/admin/rate_schedule_groups/new_editor_data`
    }
    let res = await fetch(url);
    this.data = await res.json();

    // console.log('RateScheduleGroupEditor data: ',this.data)
  }

  async connectedCallback() {
    await this.loadData()

    this.innerHTML = `
   
      <div class="row">
        <div class="col-md-12" id="editor_form_container" style="border:1px solid #ccc;padding:10px;">
          <div class="errors"></div>
          <form>
            <div class="form-group" >
              <label for="rate_schedule_group_name">Schedule Name</label>
              <input type="text" 
                class="form-control" 
                name="rate_schedule_group_name"
                id="rate_schedule_group_name"
                value="${this.data.rate_schedule_group_name}"
              placeholder="Name this Rate Schedule Group">
            </div>

            <!--
            <div class="form-group" role="form">
              <label class="xcol-md-6 control-label">Active</label>
                <div class="xcol-md-6"  align="left">
                  <label class="switch">
                    <input type="checkbox" class="form-control switch" id="active-switch" ${this.data.active ? "checked" : ""}>
                    <span data-cy="active-switch"></span>
                  </label>
                </div>
            </div>
            -->

            <div id="group_industries"></div>
            <div id="rate_schedule_cards"></div>
          </form>

          <div class="location-settings-buttons">
            <button 
              type="button" 
              class="btn btn-outline-secondary cancel  detail-row-button">Cancel
            </button>

            <button 
              type="button" 
              class="btn btn-primary save  detail-row-button" 
              data-cy="save-general-settings">Save
            </button>
          </div>

        </div> <!-- editor_form_container -->

        <div class="col-md-12" id="rate_schedule_form_parent_container" style="display:none;border:1px solid #ccc;padding:10px;">
        </div>
      </div>
    `

    this.init_groups_industries()
    this.init_rate_schedule_cards()


    this.querySelector('.cancel').addEventListener('click', function() {
      this.resetData();
    }.bind(this))
    this.querySelector('.save').addEventListener('click', function() {
      this.save();
    }.bind(this))
  }
  
  init_groups_industries() {
    let row = this.querySelector("#group_industries")
    if (row) {
      let el = document.createElement("rate-schedule-group-industries");
      el.id = this.data.rate_schedule_group_id;
      el.current_selected_industries = this.data.industries.map(industry => industry[0]);
      row.appendChild(el);
    }
  }
  
  // Renders the initial state of the rate schedule cards for this rate schedule group
  init_rate_schedule_cards() {
    let container = this.querySelector("#rate_schedule_cards")
    if (container){
      container.innerHTML = ''
      const rate_schedule_el = new RateScheduleGroupEditorRateSchedules(this.data)
      // const rate_schedule_el = document.createElement('rate-schedule-group-editor-rate-schedules')
      rate_schedule_el.parentContainerSelectorId = 'editor_form_container'
      rate_schedule_el.rateScheduleEditorSelectorId = 'rate_schedule_form_parent_container'
      container.appendChild(rate_schedule_el)
    }
  }
  
  async resetData() {
    if(await confirmPlus(`Are you sure you want to undo your changes?`)) {
      window.location.href = '/admin/rate_schedule_groups';
    }  
  }
  
  // when a rate schedule is added or updated, we need to refresh the existing data
  // based on the rate schedule id or add it to the list of rate schedules if there
  // are no matches, meaning it was just added.
  update_data(data){
    const existing_rs_index = this.data.rate_schedules.findIndex(rs => {
      return rs.id === data.id
    })
    if (existing_rs_index === -1){
      this.data.rate_schedules.push(data)
    }
    else {  
      this.data.rate_schedules[existing_rs_index] = data
    }
    
    // Find the first rate-schedule-editor-placeholder-card
    // and replace it with a editor-rate-schedule-card  
    const el = document.querySelector('rate-schedule-group-editor-rate-schedules')
    if (el){
      el.refreshUi()
    }
  }
  
  async save() {
    if(this.validate()) {
      pageLoadingFrame("show")

      // update the rate schedule ordinals. If new rate schedules are added, they have
      // an ordinal of null.
      let rate_schedules_data = []
      let ordinal_counter = 1
      this.data.rate_schedules.map(rs => {
        if (rs.rate_schedule_ordinal === null) {
          rs.rate_schedule_ordinal = ordinal_counter
        }
        ++ordinal_counter

        if (rs.rate_schedule_group_id){
          rate_schedules_data.push( {id: rs.rate_schedule_group_id, rate_schedule_id: rs.id, ordinal: rs.rate_schedule_ordinal} )
        }
        else {
          rate_schedules_data.push( {rate_schedule_id: rs.id, ordinal: rs.rate_schedule_ordinal} )
        }
      })

      const selected_industries = this.querySelector("rate-schedule-group-industries").selectedIndustries()
      let data = {
        id: this.data.rate_schedule_group_id,
        name: this.querySelector('#rate_schedule_group_name').value.trim(),
        rate_schedule_group_rate_schedules_attributes: rate_schedules_data,
        industries_attributes: selected_industries
      }

      let url = `/admin/rate_schedule_groups/${this.data.rate_schedule_group_id}/update.json`
      if (this.data.rate_schedule_group_id === null) {
        url = `/admin/rate_schedule_groups/create.json`
      }
      let result = await fetch(url, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }).catch(error => {
        pageLoadingFrame("hide")
        Common.notify('Unable to save changes because of an error.', 'danger');
        console.error('There was an error!', error);
      }); 

      let response = await result.json();
      if (response.success === true) {
        window.location = '/admin/rate_schedule_groups'
      }
      else {
        Common.notify('Unable to save changes because of an error.', 'danger');
        pageLoadingFrame("hide")
      }
    }
  }

  validate(){
    let isValid = true;
    let errors = "";
    this.querySelectorAll('.error').forEach(elem => {
      elem.classList.remove('error');
    })
    this.querySelector("rate-schedule-group-industries").removeError()

    if(!this.querySelector('#rate_schedule_group_name').value.trim()) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Please provide a name for your Rate Schedule Group.
                  </div>`;
      this.querySelector('#rate_schedule_group_name').classList.add('error')
      isValid = false;
    }

    const selected_industries = this.querySelector("rate-schedule-group-industries").selectedIndustries()
    if (selected_industries.length === 0) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> At least one industry must be selected.
                  </div>`;
      this.querySelector("rate-schedule-group-industries").showError()
      isValid = false;    
    }
    
    this.querySelector('.errors').innerHTML = errors;
    document.querySelector('.panel-heading').scrollIntoView(true)

    return isValid
  }
}
customElements.define("rate-schedule-group-editor", RateScheduleGroupEditor)
